import { useEffect, useState, useCallback } from "react"

import styled from "styled-components"

interface Props {
  className?: string
  sources: string[]
}

export default function HeroVideo({ className = "", sources }: Props) {
  const [videoRef, setVideoRef] = useState<HTMLVideoElement | null>(null)
  const [vidSrc, setVidSrc] = useState<JSX.Element[] | null>(null)

  const loadVideo = useCallback(async () => {
    const allVidSources = sources.map(async vid => {
      const el = await import(`../../static/homepage/${vid}`)

      return el.default
    })

    const srcset = await Promise.all(
      allVidSources.map(async (vid, i, arr) => {
        const res = await vid
        return (
          <source
            key={res}
            src={res}
            type={arr.length > 1 && i === 0 ? "video/webm" : "video/mp4"}
          />
        )
      })
    )

    setVidSrc(srcset)
  }, [sources])

  useEffect(() => {
    if (videoRef) {
      loadVideo()
    }
  }, [loadVideo, videoRef])

  return (
    <Vid
      className={className}
      ref={ref => setVideoRef(ref)}
      autoPlay
      playsInline
      preload="none"
      muted
    >
      {vidSrc}
    </Vid>
  )
}

const Vid = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
